export default "__VITE_ASSET__87ce39bc__"